import React, { useEffect, useState } from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    TextField,
    MenuItem,
    Stack,
} from "@mui/material";
import { db, auth } from "../firebase";
import {
    collection,
    doc,
    getDocs,
    setDoc,
    updateDoc,
    deleteDoc,
    query,
    where,
    Timestamp,
} from "firebase/firestore";

function Printsetting() {
    const [printers, setPrinters] = useState([]);
    const [kotPrinter, setKotPrinter] = useState("");
    const [billPrinter, setBillPrinter] = useState("");
    const [docId, setDocId] = useState(null);

    const [propertyId, setPropertyId] = useState(null);
    const [loadingProperty, setLoadingProperty] = useState(true);

    /* ================= GET PRINTERS FROM ELECTRON ================= */

    useEffect(() => {

        const fetchProperty = async () => {

            const user = auth.currentUser;
            if (!user) return;

            const snap = await getDocs(
                query(
                    collection(db, "authroles"),
                    where("uid", "==", user.uid)
                )
            );

            if (!snap.empty) {
                const data = snap.docs[0].data();

                setPropertyId(data.propertyId);
            }

            setLoadingProperty(false);
        };

        fetchProperty();

    }, []);

    useEffect(() => {

        const loadPrinters = async () => {

            console.log("🚀 Window Electron API:", window.electronAPI);

            if (!window.electronAPI) {
                console.error("❌ Electron API not found");
                return;
            }

            if (!window.electronAPI.getPrinters) {
                console.error("❌ getPrinters function missing");
                return;
            }

            try {
                const list = await window.electronAPI.getPrinters();
                setPrinters(list || []);

            } catch (error) {
                console.error("❌ Printer Fetch Error:", error);
            }
        };

        loadPrinters();

    }, []);

    /* ================= LOAD SAVED SETTINGS ================= */

    useEffect(() => {
        const loadSettings = async () => {
            if (!propertyId) return;

            const q = query(
                collection(db, "printerSettings"),
                where("propertyId", "==", propertyId)
            );

            const snap = await getDocs(q);

            if (!snap.empty) {
                const data = snap.docs[0].data();
                setDocId(snap.docs[0].id);
                setKotPrinter(data.kotPrinter || "");
                setBillPrinter(data.billPrinter || "");
            }
        };

        loadSettings();
    }, [propertyId]);

    /* ================= SAVE / UPDATE ================= */

    const saveSettings = async () => {
        if (!propertyId) return;

        if (docId) {
            await updateDoc(doc(db, "printerSettings", docId), {
                kotPrinter,
                billPrinter,
                updatedAt: Timestamp.now(),
            });
        } else {
            const newDoc = doc(collection(db, "printerSettings"));
            await setDoc(newDoc, {
                propertyId,
                kotPrinter,
                billPrinter,
                createdAt: Timestamp.now(),
            });
            setDocId(newDoc.id);
        }

        alert("Printer Settings Saved ✅");
    };

    /* ================= DELETE ================= */

    const deleteSettings = async () => {
        if (!docId) return;

        await deleteDoc(doc(db, "printerSettings", docId));

        setDocId(null);
        setKotPrinter("");
        setBillPrinter("");

        alert("Deleted ✅");
    };

    return (
        <Box className="" p={4}>
            <Card sx={{ borderRadius: 4, boxShadow: 3 }}>
                <CardContent>
                    <Typography variant="h5" fontWeight="bold" mb={3}>
                        🖨 Printer Settings
                    </Typography>

                    <Stack flexDirection="row" justifyContent="flex-start">

                        {/* ===== KOT PRINTER ===== */}
                        <TextField
                            select
                            label="Select KOT Printer"
                            value={kotPrinter}
                            onChange={(e) => setKotPrinter(e.target.value)}
                            size="small" sx={{ width: 300, mr: 5 }}
                        >
                            {printers.map((p) => (
                                <MenuItem key={p.name} value={p.name}>
                                    {p.name}
                                </MenuItem>
                            ))}
                        </TextField>

                        {/* ===== BILL PRINTER ===== */}
                        <TextField
                            select
                            label="Select Bill Printer"
                            value={billPrinter}
                            onChange={(e) => setBillPrinter(e.target.value)}
                            size="small" sx={{ width: 300, mr: 5 }}
                        >
                            {printers.map((p) => (
                                <MenuItem key={p.name} value={p.name}>
                                    {p.name}
                                </MenuItem>
                            ))}
                        </TextField>

                        {/* ===== BUTTONS ===== */}
                        <Stack direction="row" spacing={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={saveSettings}
                            >
                                💾 Save
                            </Button>

                            {docId && (
                                <Button
                                    variant="outlined"
                                    color="error"
                                    onClick={deleteSettings}
                                >
                                    🗑 Delete
                                </Button>
                            )}
                        </Stack>

                    </Stack>
                </CardContent>
            </Card>
        </Box>
    );
}

export default Printsetting;